const { default: Axios } = require('axios');
const Qs = require('qs');

module.exports = Axios.create({
    baseURL: process.env.API_URL,
    header: {},
    paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
    responseType: 'json'
});
